import React from 'react';
import { useSendJobs } from '../context/SendJobsContext';

export default function SendJobsFloater() {
  const { jobs, cancelJob, dismissJob } = useSendJobs();
  if (!jobs.length) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 20,
      right: 20,
      display: 'flex',
      flexDirection: 'column-reverse',
      gap: 10,
      zIndex: 9999,
      pointerEvents: 'none',
    }}>
      {jobs.map(job => {
        const pct = job.total > 0 ? (job.sent / job.total) * 100 : 0;
        const failures = job.log.filter(l => l.ok === false);
        const borderColor = job.done && job.failed > 0 ? 'rgba(239,68,68,0.4)' : job.done ? 'rgba(34,197,94,0.3)' : 'var(--border-light)';
        return (
          <div key={job.jobId} style={{
            background: 'var(--bg-card)',
            border: `1px solid ${borderColor}`,
            borderRadius: 'var(--radius)',
            padding: '12px 14px',
            width: 320,
            boxShadow: 'var(--shadow)',
            pointerEvents: 'all',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
              <div style={{ flex: 1, fontWeight: 600, fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {job.clientName}
              </div>
              <div style={{ fontSize: 12, color: 'var(--text-muted)', flexShrink: 0 }}>
                {job.sent}/{job.total}
              </div>
              {job.done ? (
                <button
                  onClick={() => dismissJob(job.jobId)}
                  title="Dismiss"
                  style={{ background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', width: 20, height: 20, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, padding: 0, flexShrink: 0 }}
                >✕</button>
              ) : (
                <button
                  onClick={() => cancelJob(job.jobId)}
                  title="Stop sending"
                  style={{ background: 'var(--red-soft)', border: '1px solid rgba(239,68,68,0.25)', borderRadius: 4, color: 'var(--red)', cursor: 'pointer', width: 22, height: 22, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, padding: 0, flexShrink: 0 }}
                >⏹</button>
              )}
            </div>
            <div style={{ height: 4, background: 'var(--bg-elevated)', borderRadius: 2, overflow: 'hidden' }}>
              <div style={{
                height: '100%',
                width: `${pct}%`,
                background: job.done ? 'var(--green)' : 'var(--accent)',
                borderRadius: 2,
                transition: 'width 0.4s ease',
              }} />
            </div>
            <div style={{ marginTop: 6, fontSize: 11, color: job.done ? (job.failed > 0 ? 'var(--red)' : 'var(--green)') : 'var(--text-muted)' }}>
              {job.done
                ? `Done — ${job.sent} sent${job.failed > 0 ? `, ${job.failed} failed` : ''}`
                : 'Sending...'}
            </div>
            {failures.length > 0 && (
              <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid var(--border-light)', display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 140, overflowY: 'auto' }}>
                {failures.map((f, i) => (
                  <div key={i} style={{ fontSize: 11, color: 'var(--red)', lineHeight: 1.4 }}>{f.msg}</div>
                ))}
              </div>
            )}
            {job.warnings?.length > 0 && (
              <div style={{ marginTop: 8, paddingTop: 8, borderTop: '1px solid var(--border-light)', display: 'flex', flexDirection: 'column', gap: 4, maxHeight: 140, overflowY: 'auto' }}>
                {job.warnings.map((w, i) => (
                  <div key={i} style={{ fontSize: 11, color: 'var(--amber, #d97706)', lineHeight: 1.4 }}>{w}</div>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
